import React, {useRef, useState} from 'react'
import {CostsTableHeader} from "./CostsTableHeader";
import {CostsTableBody} from "./CostsTableBody";
import {useSelector} from "react-redux";

interface ICostsTableProps {
    rowsSelectValue: any
    itemToEdit: any
}

export const CostsTable: React.FC<ICostsTableProps> = ({rowsSelectValue, itemToEdit}) => {

    const expenseList = useSelector((state: any) => state.toolkit.expenses)

    const [filterByProjectName, setFilterByProjectName] = useState("")
    const [filterByProjectDescription, setFilterByProjectDescription] = useState("")
    const [sortByDate, setSortByDate] = useState("ASC")
    const [sortByCost, setSortByCost] = useState("")

    const bodyScrollRef = useRef<HTMLDivElement>(null);
    const headScrollRef = useRef<HTMLDivElement>(null);

    const handleBodyScroll = () => {
        if (bodyScrollRef.current && headScrollRef.current) {
            headScrollRef.current.scrollLeft = bodyScrollRef.current.scrollLeft;
        }
    };

    return (
        <div className="section-table__main table-costs add-border">
            {/* Sticky column header outside the overflow-x container */}
            <div ref={headScrollRef} className="section-table__head-sticky-wrap">
                <div className="section-table__main--wrapper">
                    <CostsTableHeader
                        setFilterByProjectName={setFilterByProjectName}
                        setFilterByProjectDescription={setFilterByProjectDescription}
                        setSortByDate={setSortByDate}
                        setSortByCost={setSortByCost}
                    />
                </div>
            </div>
            {/* Scrollable body - horizontal scroll only */}
            <div ref={bodyScrollRef} className="section-table__main--container" onScroll={handleBodyScroll}>
                <div className="section-table__main--wrapper">
                    <CostsTableBody
                        list={expenseList}
                        rowsSelectValue={rowsSelectValue}
                        filterByProjectName={filterByProjectName}
                        filterByProjectDescription={filterByProjectDescription}
                        sortByDate={sortByDate}
                        sortByCost={sortByCost}
                        itemToEdit={itemToEdit}
                    />
                </div>
            </div>
        </div>
    )
}
